// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"t4-z","displaySixCardTiles":"u4-z"};